import _extends from "@babel/runtime/helpers/extends";
import React, { useContext, useMemo } from 'react';
import { StencilContext, styledWithTheme } from "../context";
import { Row } from "../layout";
import { Text } from "../text";
import { filterProps, getUniqueId } from "../utils";
import { DEFAULT_COLOR_SCHEME, INVERTED_COLOR_SCHEME } from "./avatarConstants";
import { AvatarColorScheme } from "./interfaces";
import { jsx as ___EmotionJSX } from "@emotion/core";
var StyledUsername = styledWithTheme(Text)(function (_ref) {
  var theme = _ref.theme,
      color = _ref.color,
      fontWeight = _ref.fontWeight;
  return {
    color: theme.selectors.color(color || 'neutral70'),
    fontWeight: theme.selectors.fontWeight(fontWeight || 'regular')
  };
});
var StyledLinkRow = styledWithTheme(Row, {
  shouldForwardProp: filterProps(['fontWeight'])
})(function (_ref2) {
  var theme = _ref2.theme,
      fontWeight = _ref2.fontWeight;
  return {
    fontWeight: theme.selectors.fontWeight(fontWeight)
  };
});

var AvatarUsername = function AvatarUsername(_ref3) {
  var username = _ref3.username,
      fontSize = _ref3.fontSize,
      lineHeight = _ref3.lineHeight,
      fontWeight = _ref3.fontWeight,
      isUsernameClickable = _ref3.isUsernameClickable,
      newTabHiddenText = _ref3.newTabHiddenText,
      colorScheme = _ref3.colorScheme,
      renderLink = _ref3.renderLink;

  var _useContext = useContext(StencilContext),
      selectors = _useContext.selectors;

  var accessibleUsername = ___EmotionJSX(React.Fragment, null, username, ___EmotionJSX("span", {
    "aria-hidden": "true"
  }, '@'));

  var uniqueId = useMemo(function () {
    return "new-tab-hidden-text-".concat(getUniqueId());
  }, []);
  var textColor = colorScheme === AvatarColorScheme.Inverted ? INVERTED_COLOR_SCHEME.textColor : DEFAULT_COLOR_SCHEME.textColor;
  var textProps = {
    fontSize: fontSize,
    lineHeight: lineHeight,
    fontWeight: fontWeight,
    color: textColor
  };

  if (isUsernameClickable) {
    return ___EmotionJSX(StyledLinkRow, {
      "data-test-component": "AvatarUsername",
      fontWeight: fontWeight
    }, renderLink({
      username: username,
      accessibleUsername: accessibleUsername,
      newTabHiddenText: newTabHiddenText,
      selectors: selectors,
      lineHeight: lineHeight,
      fontSize: fontSize,
      colorScheme: colorScheme,
      id: uniqueId
    }));
  }

  return ___EmotionJSX(StyledUsername, _extends({}, textProps, {
    "data-test-component": "AvatarUsername"
  }), accessibleUsername);
};

export default AvatarUsername;